import React from "react";
import { FormGroup, Button, PasswordInput } from "@accessdev/arc-ui-react";
import { PASSWORD_MIN_STR } from "@Src/constants/Constants";
import { Trans } from "@lingui/react/macro";
import Captcha from "../Captcha";
import TermsAgreement from "./TermsAgreement";

const Password = (props) => {
  const onSubmit = () => {
    props.completeSignUp();
  };

  return (
    <>
      <FormGroup onSubmit={onSubmit}>
        <div className="SignUp-form_passwords">
          <div className="SignUp-form_pwContainer">
            <PasswordInput value={props.values.password} handleChange={props.onPasswordChange} />
          </div>
        </div>
        <Captcha
          doReveal={props.values.passwordStr >= PASSWORD_MIN_STR}
          onVerify={props.onCaptchaVerify}
        />
        <Button
          type="submit"
          className="SignUpWizard-nextSubmitBtn"
          isDisabled={props.isButtonDisabled(props.isPhone)}
        >
          <Trans>Sign Up</Trans>
        </Button>
      </FormGroup>
      <TermsAgreement />
    </>
  );
};

export default Password;
